import { HomeIcon } from "@heroicons/react/24/outline";
import { Primary } from "../buttons/Primary"

export function Blogs(props) {
  return (
    <>
      <div className="bg-white py-20 lg:pb-28 px-4 sm:px-6 lg:px-52 lg:w-3/4">
        <div className="pt-8 lg:pt-8">
          <div className="flex py-10 text-purple font-light">
            <HomeIcon className="w-6 h-auto mr-1" />
            <a href="/blog" className="text-xl lg:text-2xl hover:underline">
              Home
            </a>
          </div>
          <h1 className="text-3xl lg:text-6xl tracking-tight">
            {props.title}
          </h1>
        </div>
        <div className="tracking-tight">{props.content}</div>
        <div className="pt-10">
          <span className="text-2xl font-bold">Lee también:</span>
          <div className="py-10 text-2xl">
            <div className="flex">
              <span className="font-bold pr-4">-</span>
              {props.enlace1}
            </div>
            <div className="flex pt-6">
              <span className="font-bold pr-4">-</span>
              {props.enlace2}
            </div>
            <div className="flex pt-6">
              <span className="font-bold pr-4">-</span>
              {props.enlace3}
            </div>
          </div>
        </div>
        <div className="pt-10 font-bold text-2xl">
          <p className="">
            En Galilea queremos revolucionar el sistema financiero donde se democratice el acceso a sus servicios y productos a través de innovación en nuevas tecnologías, únete a nuestro mundo.
          </p>          
        </div>
        <div className="w-1/2 mt-8"><a href="/registrarse"><Primary text={'Unirme ahora'}/></a></div>
      </div>
    </>
  );
}
